<template>
  <div>
    <input class="oct-gn-menustate" type="checkbox" id="oct-gn-menustate" tabindex="-1" aria-hidden="true"/>
    <nav class="oct-globalnav" role="navigation" id="oct-globalnav">
      <div class="oct-gn__content">
        <section class="oct-gn__section">
          <label class="oct-gn-menuicon" data-toggle="tray" for="oct-gn-menustate">
            <span class="oct-gn-menuicon-bread oct-gn-menuicon-bread--top"></span>
            <span class="oct-gn-menuicon-bread oct-gn-menuicon-bread--bottom"></span>
          </label>
          
          <div class="oct-gn-breadcrumbs">
            <a class="oct-gn__logo" :href="`${domain}/`">
              <svg viewBox="0 0 241 50" class="oct-icon__marph">
                <use xlink:href="#oct-icon__marph"></use>
              </svg>
            </a>

            <span
              class="oct-gn-breadcrumbs__item"
              v-for="(item, i) in breadcrumbs"
              :key="i"
            >
            /
            <component
              class="oct-gn-breadcrumbs__link"
              :is="item.href ? 'a' : 'span'"
              :href="`${domain}${item.href}`"
            >
              {{ item.text }}
            </component>
            </span>
          </div>
        </section>
        
        <!--
        <section class="oct-gn__section oct-gn__section--align-end" v-if="actions && (!user || !user.id)">
          <oct-button
            size="small"
            outline
            @click.native="$emit('signin')"
          >
            LOG IN
          </oct-button>
          <oct-button
            size="small"
            type="primary"
            @click.native="$emit('signup')"
          >
            SIGN UP
          </oct-button>
        </section>
        -->

        <section class="oct-gn__section oct-gn__section--align-end oct-gn__user" v-if="actions && user && user.id">
          <div class="oct-gn-account">
            <span class="oct-gn-account__primary-text" @click="goHome">
              {{ getLocaleString(user, 'tradeName') || user.displayName }}
            </span>

            <figure
              class="oct-gn-account__icon"
              :class="{
                'oct-gn-account__icon--circle' : user.profileIcon && user.profileIcon.lowResolution
              }"
              @click="goHome"
            >
              <picture class="oct-gn-account__picture">
                <img
                  class="oct-gn-account__image"
                  :src="user.profileIcon.lowResolution"
                  :alt="getLocaleString(user, 'tradeName') || user.displayName || ''"
                  v-if="user.profileIcon && user.profileIcon.lowResolution"
                />
                <oct-icon
                  class="oct-gn-account__image"
                  icon="account-circle"
                  v-else
                />
              </picture>
            </figure>

            <div class="oct-gn-account-menu">
              <div class="oct-gn-account-menu__content">
                <div class="oct-gn-account-menu__section">
                  <span class="oct-gn-account-menu__title-text">CURRENTLY IN</span>

                  <component
                    :is="user.type === 'user' ? 'span' : 'a'"
                    :href="user.type === 'user' ? null : `${domain}${user.type === 'artist' ? '/artists/' : '/spaces/'}${user.displayName}`"
                    class="oct-gn-account-menu__user"
                  >
                    <figure class="oct-gn-account-menu__icon">
                      <img
                        class="oct-gn-account-menu__image"
                        :src="user.profileIcon.lowResolution"
                        :alt="getLocaleString(user, 'tradeName') || user.displayName || ''"
                        v-if="user.profileIcon && user.profileIcon.lowResolution"
                      />
                      <oct-icon
                        class="oct-gn-account-menu__image"
                        icon="account-circle"
                        v-else
                      />
                    </figure>

                    <div class="oct-gn-account-menu__profile">
                      <span class="oct-gn-account-menu__primary-text">{{ getLocaleString(user, 'tradeName') || user.displayName || '' }}</span>
                      <span class="oct-gn-account-menu__secondary-text">{{ user.type }}</span>
                      <span class="oct-gn-account-menu__secondary-text">{{ user.email || '' }}</span>
                    </div>
                  </component>
                </div>

                <div class="oct-gn-account-menu__section">
                  <span class="oct-gn-account-menu__title-text">YOUR ACCOUNT</span>

                  <ul class="oct-gn-account-menu__list">
                    <li class="oct-gn-account-menu__list-item">
                      <a
                        :href="`${domain}/account/saves-follows`"
                        class="oct-gn-account-menu__link"
                      >
                        Saves & Follows
                      </a>
                    </li>
                    <li
                      class="oct-gn-account-menu__list-item"
                      v-if="user && user.type === 'su'"
                    >
                      <a
                        :href="`${domain}/account/management/mailnews/`"
                        class="oct-gn-account-menu__link"
                      >
                        Mail Magazine
                      </a>
                    </li>
                    <!-- Link to media management page, only for super user -->
                    <li
                      class="oct-gn-account-menu__list-item"
                      v-if="user && user.type === 'su'"
                    >
                      <a
                        :href="`${domain}/account/management/media/`"
                        class="oct-gn-account-menu__link"
                      >
                        Media
                      </a>
                    </li>
                    <!-- Link to user management page, only for super user -->
                    <li
                      class="oct-gn-account-menu__list-item"
                      v-if="user && user.type === 'su'"
                    >
                      <a
                        :href="`${domain}/account/management/users/`"
                        class="oct-gn-account-menu__link"
                      >
                        User Management
                      </a>
                    </li>
                    <!--
                    <li
                      class="oct-gn-account-menu__list-item"
                      v-if="user && user.type === 'user'"
                    >
                      <a
                        :href="`${domain}/account/saves-follows`"
                        class="oct-gn-account-menu__link"
                      >
                        Convert to Artist / Gallery
                      </a>
                    </li>
                    -->
                    <li
                      class="oct-gn-account-menu__list-item"
                      v-if="user && (user.type === 'artist' || user.type === 'gallery')"
                    >
                      <a
                        :href="`${domain}/account/dashboard`"
                        class="oct-gn-account-menu__link"
                      >
                        Mypage
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="oct-gn-account-menu__section">
                  <span class="oct-gn-account-menu__title-text">MORE OPTIONS</span>

                  <ul class="oct-gn-account-menu__list">
                    <li class="oct-gn-account-menu__list-item">
                      <a
                        :href="`${domain}/account/settings`"
                        class="oct-gn-account-menu__link"
                      >
                        Settings
                      </a>
                    </li>
                    <!-- Link to impersonation page, only for super user -->
                    <li
                      class="oct-gn-account-menu__list-item"
                      v-if="user && user.type === 'su'"
                    >
                      <a
                        :href="`${domain}/account/management/impersonate/`"
                        class="oct-gn-account-menu__link"
                      >
                        Login as...
                      </a>
                    </li>
                    <li
                      class="oct-gn-account-menu__list-item"
                      v-if="user.impersonated"
                    >
                      <span
                        class="oct-gn-account-menu__link"
                        @click="$emit('signout', true)"
                      >
                        Log out from {{ getLocaleString(user, 'tradeName') || user.displayName }}
                      </span>
                    </li>
                    <li class="oct-gn-account-menu__list-item">
                      <!-- @event 'signout' -->
                      <span
                        class="oct-gn-account-menu__link"
                        @click="$emit('signout')"
                      >
                        Log out
                      </span>
                    </li>
                  </ul>
                </div>

                <!-- Account Switcher -->
                <div
                  class="oct-gn-account-menu__section oct-gn-account-menu__section--account"
                  v-if="relatedAccounts.length"
                >
                  <span class="oct-gn-account-menu__title-text">LOG IN WITH ANOTHER ACCOUNT</span>

                  <span
                    class="oct-gn-account-menu__user"
                    v-for="item in relatedAccounts"
                    :key="item.id"
                    @click="$emit('signout', item.email)"
                  >
                    <figure class="oct-gn-account-menu__icon">
                      <img
                        class="oct-gn-account-menu__image"
                        :src="item.profileIcon.lowResolution"
                        :alt="getLocaleString(item, 'tradeName') || item.displayName || ''"
                        v-if="item.profileIcon && item.profileIcon.lowResolution"
                      />
                      <oct-icon
                        class="oct-gn-account-menu__image"
                        icon="account-circle"
                        v-else
                      />
                    </figure>

                    <div class="oct-gn-account-menu__profile">
                      <span class="oct-gn-account-menu__primary-text">{{ getLocaleString(item, 'tradeName') || item.displayName || '' }}</span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="oct-gn-drawer">
        <div class="oct-gn-drawer__content">
          <ul class="oct-gn-directory-list">
            <li class="oct-gn-directory-list__item">
              <a :href="`${domain}/artists`" class="oct-gn-directory-list__link">Artists</a>
            </li>
            <li class="oct-gn-directory-list__item">
              <a :href="`${domain}/artworks`" class="oct-gn-directory-list__link">Artworks</a>
            </li>
            <li class="oct-gn-directory-list__item">
              <a :href="`${domain}/spaces`" class="oct-gn-directory-list__link">Galleries &amp; Museums</a>
            </li>
            <li class="oct-gn-directory-list__item">
              <a :href="`${domain}/exhibitions`" class="oct-gn-directory-list__link">Exhibitions</a>
            </li>
            <li class="oct-gn-directory-list__item">
              <a :href="`${domain}/pr`" class="oct-gn-directory-list__link">Press Releases</a>
            </li>
            <li class="oct-gn-directory-list__item">
              <a :href="`${domain}/about`" class="oct-gn-directory-list__link">About</a>
            </li>
          </ul>

          <ul class="oct-gn-social-list">
            <li class="oct-gn-social-list__item">
              <oct-icon-button type="primary" size="small" icon="instagram" href="https://www.instagram.com/marphcom/" target="_blank" />
            </li>
          </ul>

          <ul class="oct-gn-legal-list">
            <li class="oct-gn-legal-list__item">
              <a href="https://marph.tayori.com/q/marph-faq/" target="_blank" class="oct-gn-legal-list__link">FAQ</a>
            </li>
            <li class="oct-gn-legal-list__item">
              <a :href="`${domain}/terms-of-use`" class="oct-gn-legal-list__link">利用規約</a>
            </li>
            <li class="oct-gn-legal-list__item">
              <a :href="`${domain}/privacy-policy`" class="oct-gn-legal-list__link">プライバシ−ポリシー</a>
            </li>
            <li class="oct-gn-legal-list__item">
              <a :href="`${domain}/company`" class="oct-gn-legal-list__link">運営会社</a>
            </li>
            <li class="oct-gn-legal-list__item">
              <a href="https://marph.tayori.com/f/contact-us/" target="_blank" class="oct-gn-legal-list__link">お問い合わせ</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <label for="oct-gn-menustate" class="oct-gn__backdrop"></label>

    <div class="oct-gn__placeholder"></div>
  </div>
</template>

<script>
import OctComponent from '@/components/base/component'
import OctIcon from '@/components/icon/OctIcon.vue';
import OctIconButton from '@/components/icon-button/OctIconButton.vue';
import OctButton from '@/components/button/OctButton.vue';

export default {
  name: 'OctGlobalnav',
  mixins: [ OctComponent ],
  components: { OctIcon, OctIconButton, OctButton },
  props: {
    /** User logged in  */
    user: {
      type: Object,
      default: () => {}
    },
    /**
     * Bread crumbs
     * @property {string} [].text Text
     * @property {string} [].href Link (nullable)
    */
    breadcrumbs: {
      type: Array,
      default: () => [{text: 'MYPAGE', href: '/account/dashboard'}]
    },
    /** Show actions */
    actions: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    /** GEt account type string */
    accountType () {
      // Invalid user
      if (!this.user) return ''

      return this.user.type === 'user' ? 'Personal' : this.user.type
    },
    /** Domain */
    domain () {
      return /^(marph\.com|stg\.marph\.com|localhost)$/.test(location.hostname) ? '' :
        'https://marph.com'
    },
    /** Related accounts */
    relatedAccounts: vm => vm.user.data.relatedAccounts.filter(item => item.email)
  },
  methods: {
    /** Go home */
    goHome () {
      // Ignore normal user
      if (this.user.type !== 'artist' && this.user.type !== 'gallery') return

      const menu = this.$el.querySelector('.oct-gn-account-menu')

      // Wait for menu open
      if (menu.clientHeight < 100) return

      location.href = '/account/dashboard'
    }
  },
  mounted () {
    this.user && this.user.id && this.$el.classList.add('oct-globalnav--authenticated')
  },
  watch: {
    /** Watch user updates */
    user () {
      this.user.id && this.$el.classList.add('oct-globalnav--authenticated')
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-globalnav {
  font-family: $font-family-sans-serif-ja;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
}

.oct-gn-menustate {
  display: none;
}

.oct-gn__content {
  color: $oct-theme--primary;
  fill: $oct-theme--primary;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: stretch;
  height: oct-rem(64);
  padding: 0 oct-rem(20) 0 0;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  height: oct-rem(96);
  padding: oct-rem(32) oct-rem(40);
}
}

.oct-gn__section {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  height: 100%;
  overflow: hidden;

  &--align-end {
    flex: 0 0 auto;
    max-width: 33.33%;
    justify-content: flex-end;
    overflow: visible;
  }

  .oct-auth--unauthenticated &--align-end {
    max-width: 50%;
  }

  .oct-button {
    flex: 0 0 auto;
    margin-left: oct-rem(8);
  }

@media print, screen and (min-width: map-get($grid-breakpoints, 'md')) {
}
}

.oct-gn-breadcrumbs {
  line-height: 1;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  max-height: oct-rem(28);
  overflow: auto;
  overflow-y: hidden;
  
@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  overflow: auto;
}
}

.oct-gn__logo,
.oct-gn-breadcrumbs__item,
.oct-gn-breadcrumbs__link {
  font-family: $font-family-sans-serif;
  font-size: oct-rem(15);
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  color: $oct-theme--primary;
  position: relative;
  z-index: 1;
  transition-duration: .2s;

  .oct-globalnav--negative & {
   color: $oct-theme--on-primary;
  }

  .oct-gn-menustate:checked + .oct-globalnav--negative & {
    color: $oct-theme--primary;
  }

  &:hover {
    opacity: .6;
  }
}

.oct-gn__logo {
  fill: $oct-theme--primary;
  display: inline-block;
  margin-right: oct-rem(6);
  flex: 0 0 auto;
  width: oct-rem(57.7);
  height: oct-rem(12);

  .oct-globalnav--negative & {
    fill: $oct-theme--on-primary;
  }

  .oct-gn-menustate:checked + .oct-globalnav--negative & {
    fill: $oct-theme--primary;
  }

  .oct-icon__marph {
    vertical-align: top;
    width: 100%;
    height: 100%;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-right: oct-rem(42);
}
}

.oct-gn-menuicon {
  position: relative;
  margin: 0;
  display: inline-block;
  flex: 0 0 oct-rem(66);
  width:  oct-rem(66);
  height: 100%;
  cursor: pointer;
  z-index: 1;
  -webkit-tap-highlight-color: rgba(0,0,0,0);

@media print, screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin: 0 oct-rem(72) 0 0;
  flex: 0 0 oct-rem(32);
  width: oct-rem(32);
  height: oct-rem(32);
}
}

.oct-gn-menuicon-bread {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: oct-rem(-1) auto;
  width: oct-rem(26);
  height: oct-rem(2);
  background-color: $oct-theme--primary;
  transition-duration: .3s;

  .oct-globalnav--negative & {
    background-color: $oct-theme--on-primary;
  }

  .oct-gn-menuicon:hover & {
    transition-duration: .2s;

    &--top {
      transform: translateY(oct-rem(-6));
    }

    &--bottom {
      transform: translateY(oct-rem(6));
    }
  }

  &--top {
    transform: translateY(oct-rem(-4));
  }

  &--bottom {
    transform: translateY(oct-rem(4));
  }

  .oct-gn-menustate:checked + .oct-globalnav & {
    &--top {
      animation: .3s linear 0s 1 forwards close__top;
    }

    &--middle {
      opacity: 0;
    }

    &--bottom {
      animation: .3s linear 0s 1 both close__bottom;
    }
  }

  .oct-gn-menustate:checked + .oct-globalnav--negative & {
    background-color: $oct-theme--primary;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  width: 100%;

  &--top {
    transform: translateY(oct-rem(-5));
  }

  &--bottom {
    transform: translateY(oct-rem(5));
  }

  .oct-gn-menuicon:hover & {
    &--top {
      transform: translateY(oct-rem(-8));
    }

    &--bottom {
      transform: translateY(oct-rem(8));
    }
  }
}
}

@keyframes close__top {
  0% { } 
  60% { transform: translateY(0); }
  100% { transform: translateY(0) rotate(-45deg); }
}

@keyframes close__bottom {
  0% {} 
  60% { transform: translateY(0); }
  100% { transform: translateY(0) rotate(45deg); }
}

.oct-gn__actions {
  display: none;

  .oct-auth--unauthenticated & {
    display: flex;
  }
}

.oct-gn__user {
  display: none;

  .oct-globalnav--negative & {
    color: #fff;
  }

  .oct-globalnav--authenticated & {
    display: flex;
  }

  &:hover {
    .oct-gn-account__icon:after {
      display: block;
    }
  }

@media print, screen and (min-width: map-get($grid-breakpoints, 'md')) {
  flex: 1 1 auto;
}
}

.oct-gn__icon {
  fill: $oct-theme--primary;
  display: flex;
  justify-content: center;
  align-items: center;
  width: oct-rem(28);
  height: oct-rem(28);
  cursor: pointer;
  border-radius: oct-rem(4);

@media print, screen and (min-width: map-get($grid-breakpoints, 'md')) {
  fill: $oct-theme--on-primary;
  width: oct-rem(30);
  height: oct-rem(30);
}
}

.oct-gn__text {
  font-size: oct-rem(11);
  font-weight: 300;
  line-height: 1;
  display: block;
  margin-right: oct-rem(2);

@media print, screen and (min-width: map-get($grid-breakpoints, 'md')) {
  font-size: oct-rem(11);
  font-weight: 600;
  color: $oct-theme--secondary;
  margin-right: oct-rem(3);
}
}

.oct-gn__pipe-item {
  &:before {
    content: "";
    margin: 0 oct-rem(4);
    display: inline-block;
    width: oct-rem(.99);
    height: oct-rem(11);
    background-color: #666;
    vertical-align: text-top;
  }

  &:first-child {
    &:before {
      content: none;
    }
  }
}

.oct-gn-drawer {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  max-height: 0;
  overflow: hidden;
  transition-duration: .5s;

  .oct-gn-menustate:checked + .oct-globalnav & {
    max-height: oct-rem(520+64);
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  .oct-gn-menustate:checked + .oct-globalnav & {
    max-height: oct-rem(522);
  }
}
}

.oct-gn-drawer__content {
  padding: oct-rem(46+64) oct-rem(66) oct-rem(72);
  background-color: $oct-theme--on-primary;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  display: flex;
  flex-wrap: wrap;
  padding: oct-rem(136) 0 oct-rem(80) oct-rem(244);
}
}

.oct-gn-directory-list {
  margin: oct-rem(-7) 0 oct-rem(-7+48);
  padding: 0;
  list-style: none;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-bottom: oct-rem(-7+68);
  flex: 0 0 100%;
}
}

.oct-gn-directory-list__link {
  font-family: $font-family-sans-serif;
  font-size: oct-rem(21);
  line-height: (30/21);
  text-decoration: none;
  color: $oct-theme--primary;
  transition-duration: .2s;

  &:hover {
    opacity: .6;
  }
}

.oct-gn-social-list {
  margin: 0 0 oct-rem(48);
  display: flex;
  padding: 0;
  list-style: none;

  .oct-icon-button {
    margin-right: oct-rem(8);
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin: 0 oct-rem(80) 0 0;
  min-width: oct-rem(124);
}
}

.oct-gn-legal-list {
  margin: oct-rem(-6) 0;
  padding: 0;
  list-style: none;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-top: oct-rem(-6+8);
  column-count: 2;
}
}

.oct-gn-legal-list__item {
@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  min-width: oct-rem(204);
}
}

.oct-gn-legal-list__link {
  font-size: oct-rem(15);
  line-height: (24/15);
  text-decoration: none;
  color: $oct-theme--primary;
  transition-duration: .2s;

  &:hover {
    opacity: .6;
  }
}

.oct-gn-account {
  position: relative;
  flex: 1 1 auto;
  max-width: 100%;
  display: flex;
  align-items: center;
  padding: oct-rem(8) 0;
}

.oct-gn-account__primary-text {
  font-size: oct-rem(15);
  line-height: (20/15);
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 oct-rem(16) 0 0;
  flex: 1 1 auto;
  overflow: hidden;

  .oct-auth--artist .oct-gn__user &, .oct-auth--gallery .oct-gn__user & {
    cursor: pointer;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  text-align: right;
}
}

.oct-gn-account__icon {
  position: relative;
  flex: 0 0 oct-rem(32);
  max-width: oct-rem(32);
  height: oct-rem(32);
  border-radius: 50%;

  .oct-auth--artist .oct-gn__user &, .oct-auth--gallery .oct-gn__user & {
    cursor: pointer;
  }

  &--circle {
    padding: oct-rem(2);
    border: oct-rem(2) solid $oct-theme--primary;
  }

  .oct-globalnav--negative & {
    border-color: $oct-theme--on-primary;
  }

  .oct-auth--user &--circle {
    border-color: transparent;
  }

  &:after {
    content: "";
    position: absolute;
    top: -100%;
    right: -100%;
    bottom: -100%;
    left: -100%;
    margin: auto;
    display: none;
    width: oct-rem(40);
    height: oct-rem(40);
    background-color: $oct-theme--primary;
    border-radius: 50%;
    opacity: .07;
    z-index: -1;
  }
}

.oct-gn-account__picture {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
}

.oct-gn-account__image {
  width: 100%;
  height: 100%;
  object-fit: cover;

  &.oct-icon__account-circle {
    display: none;
  }

  .oct-auth--user & {
    display: none;

    &.oct-icon__account-circle {
      display: block;
    }
  }

  .oct-globalnav--negative &.oct-icon__account-circle {
    fill: $oct-theme--on-primary;
  }
}

.oct-gn-account-menu {
  position: absolute;
  top: 100%;
  right: 0;
  max-height: 0;
  transition-duration: .5s;
  overflow: hidden;

  .oct-globalnav--negative & {
    color: $oct-theme--primary;
  }

  .oct-gn-account:hover & {
    transition-duration: .8s;
    max-height: oct-rem(800);
  }
}

.oct-gn-account-menu__content {
  width: oct-rem(282);
  padding: oct-rem(20) oct-rem(16);
  background-color: $oct-theme--on-primary;
  border-radius: oct-rem(12);
}

.oct-gn-account-menu__section {
  margin: 0 0 oct-rem(32);

  &:last-child {
    margin-bottom: 0;
  }
}

.oct-gn-account-menu__icon {
  margin: 0 oct-rem(12) 0 0;
  flex: 0 0 oct-rem(48);
  max-width: oct-rem(48);
  height: oct-rem(48);
  overflow: hidden;
  border-radius: 50%;
}

.oct-gn-account-menu__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.oct-gn-account-menu__title-text {
  font-size: oct-rem(13);
  line-height: (18/13);
  margin: (-4em/13) 0 ((-4em+16)/13);
  display: block;
  opacity: .55;
}

.oct-gn-account-menu__user {
  text-decoration: none;
  color: inherit;
  display: flex;

  .oct-auth--artist .oct-gn__user &, .oct-auth--gallery .oct-gn__user & {
    cursor: pointer;
  }

  .oct-gn-account-menu__section--account & {
    padding: oct-rem(8) 0;
    align-items: center;
    border-bottom: 1px solid $oct-theme--secondary-border;
    cursor: pointer;

    &:last-child {
      padding-bottom: 0;
      border-bottom-width: 0;
    }
  }

  .oct-gn-account-menu__section--account .oct-gn-account-menu__title-text + & {
    padding-top: 0;
  }
}

.oct-gn-account-menu__profile {
  overflow: hidden;
}

.oct-gn-account-menu__primary-text {
  font-size: oct-rem(15);
  line-height: (20/15);
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: (-4em/15) 0 ((-4em+8)/15);
  display: block;
  overflow: hidden;
  transition-duration: .7s;

  .oct-auth--artist .oct-gn-account-menu__profile:hover &,
  .oct-auth--gallery .oct-gn-account-menu__profile:hover & {
    opacity: .6;
  }

  .oct-gn-account-menu__section--account & {
    margin: 0;
  }
}

.oct-gn-account-menu__secondary-text {
  font-size: oct-rem(13);
  line-height: (16/13);
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: (-3em/13) 0 ((-3em+6)/13);
  display: block;
  opacity: .55;
  overflow: hidden;

  .oct-gn-account-menu__primary-text + & {
    text-transform: capitalize;
  }

  &:last-child {
    margin-bottom: (-3em/13);
  }
}

.oct-gn-account-menu__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.oct-gn-account-menu__list-item {
  font-size: oct-rem(15);
  line-height: (28/15);
  margin: (-8em/15) 0 ((-8em+16)/15);

  &:last-child {
    margin-bottom: 0;
  }

  .oct-auth--su &--dashboard,
  .oct-auth--user &--dashboard {
    display: none;
  }

  .oct-auth--artist &--conversion, .oct-auth--gallery &--conversion {
    display: none;
  }
}

.oct-gn-account-menu__link {
  color: inherit;
  text-decoration: none;
  margin: 0;
  display: block;
  cursor: pointer;
  transition-duration: .2s;

  &:hover {
    opacity: .6;
  }
}

.oct-gn__backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  z-index: 4;

  .oct-gn-menustate:checked + .oct-globalnav + & {
    display: block;
  }
}

.oct-gn__placeholder {
  height: oct-rem(64);

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  height: oct-rem(96);
}
}
</style>
